import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import { TreinamentoInput, treinamentoSchema, treinamentos } from 'service/api'
import { toast } from 'sonner'
import { useTreinamentosOutletContext } from 'templates/Admin/Clientes/atoms/Pages/Cobrancas.context'
import FormTreinamento from '../../forms/FormTreinamento'

export default function EditarTreinamento() {
    const navigate = useNavigate()
    const { treinamentoId } = useParams()
    const { data, clienteId } = useTreinamentosOutletContext()
    const treinamento = data.find(item => item.id === Number(treinamentoId))

    const { mutate, isLoading } = treinamentos.mutations.useUpdate({
        invalidateQuery: true,
        queryParams: { clienteId: String(clienteId) },
    })

    const handleClose = () => navigate(-1)

    const handleSubmit: SubmitHandler<TreinamentoInput> = ({
        Tecnico,
        data: dataTreinamento,
        observacao,
        quemRecebeu,
        cobranca,
    }) => {
        mutate(
            {
                id: Number(treinamentoId),
                data: dayjs(dataTreinamento).toISOString(),
                quemRecebeu,
                usuarioId: Tecnico.id,
                observacao: observacao || null,
                cobranca,
            },
            {
                onSuccess: () => {
                    toast.success('Treinamento atualizado com sucesso!')
                    handleClose()
                },
                onError: () => {
                    toast.error('Erro ao atualizar o treinamento!')
                },
            },
        )
    }

    if (!treinamento) return null

    return (
        <Dialog.Root
            open={hasPermission(['update', 'Treinamentos'])}
            width="2xl"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={treinamentoSchema}
            defaultValues={{
                data: dayjs(treinamento.data).format('YYYY-MM-DDTHH:mm'),
                quemRecebeu: treinamento.quemRecebeu,
                observacao: treinamento.observacao ?? '',
                cobranca: treinamento.cobranca,
                Tecnico: {
                    id: treinamento.Usuario.id,
                    email: treinamento.Usuario.email,
                    nome: treinamento.Usuario.email.split('@')[0],
                },
            }}
        >
            <Dialog.Title action="Editar treinamento">
                {treinamento.quemRecebeu} ·{' '}
                {dayjs(treinamento.data).format('DD/MM/YYYY')}
            </Dialog.Title>
            <Dialog.Content>
                <FormTreinamento />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
